<script setup lang="ts">
const props = defineProps<{
  value: number
  itemsPerPage: number
  itemCount: number
  loading: boolean
}>()

const emit = defineEmits(['update:value'])

const pageLocal = ref(props.value)
const pageCount = computed(() => {
  return props.itemCount / props.itemsPerPage
})

const progressBar = useLoadingIndicator()
watch(
  () => props.loading,
  (newVal) => {
    if (newVal) {
      progressBar.start()
    } else {
      progressBar.finish()
    }
    pageLocal.value = props.value
  }
)

watch(
  () => pageLocal.value,
  () => {
    emit('update:value', pageLocal.value)
  }
)
</script>

<template>
  <UPagination
    v-if="pageCount > 1"
    v-model="pageLocal"
    :page-count="props.itemsPerPage"
    :total="props.itemCount"
    :max="7"
    size="lg"
    :active-button="{
      color: 'black',
    }"
    :ui="{
      rounded: '',
    }"
  />
</template>

<style scoped></style>
